import {Directive, ElementRef, EventEmitter, HostListener, Output, TemplateRef, ViewChild} from '@angular/core';

@Directive({
  selector: '[clickOutside]',
})
export class ClickOutsideDirective {

  constructor(private elementRef: ElementRef) {
  }

  @Output()
  public clickOutside = new EventEmitter();

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    let isInContainer;
    let parentContainer = targetElement;

    do {
      isInContainer = parentContainer === this.elementRef.nativeElement;
      parentContainer = parentContainer.parentNode;
    }
    while (!isInContainer && parentContainer);

    if (!parentContainer && !isInContainer){
      this.clickOutside.emit();
    }
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/widgets/growl/directives/click-outside.directive.ts